<template>
  <div class="mx-auto col-md-10">
    <el-divider class="divider-green"></el-divider>
    <el-card class="box-card" shadow="always">
      <div class="row document-upload">

        <div class="col-sm-6">
          <div class="pt-20">
            <label for="">Remarks</label>
            <el-input
              type="textarea"
              :rows="5"
              placeholder="Remarks..."
              v-model="form.remark"
            />
          </div>
          <div class="pt-20">
            <input
              type="file"
              id="file"
              ref="file"
              accept=".pdf,.png,.jpg,.jpeg"
              @change="handleFileUpload()"
            />
            <div class="el-upload__tip" slot="tip">
              <strong>
                <small
                  >*.pdf/.png/.jpg/.jpeg/
                  Document files with a size less than 10MB</small
                >
              </strong>
            </div>
          </div>
          <el-divider class="divider-green"></el-divider>
          <div>
            <base-button
              :disabled="savingDocument"
              type="primary"
              @click="submitDocument()"
              >{{ savingDocument ? "Saving..." : "Add" }}
            </base-button>
          </div>
        </div>
      </div>
      <el-divider class="divider-green"></el-divider>

      <div class="row">
        <div class="col-sm-12">
          <el-table
            :data="documents?.filter((e) => e.fileTypeNames.includes('PARTNER NATION'))"
            empty-text="No Order documents found"
            border
            fit
            class="document-table"
          >
            <el-table-column width="60" type="index"> </el-table-column>
            <el-table-column
              min-width="190"
              prop="fileName"
              label="File Name"
            ></el-table-column>
            <el-table-column
              min-width="190"
              prop="fileSizeInBytes"
              label="File Size(byte)"
            ></el-table-column>
             
            <el-table-column
              min-width="190"
              prop="createBy"
              label="Uploaded By"
            ></el-table-column>
            <el-table-column min-width="190" label="Uploaded Date">
              <template slot-scope="scope"
                >{{ formatDate(scope.row.createDate) }}
              </template></el-table-column
            >
             <el-table-column min-width="190" prop="remark" label="Remark">
              <editable-cell
                :show-input="row.editMode"
                slot-scope="{ row }"
                v-model="row.remark"
              >
                <span slot="content">{{
                  row.remark != "null" ? row.remark : ""
                }}</span>
              </editable-cell>
            </el-table-column>
            <el-table-column label="Operations" min-width="190">
              <template slot-scope="{ row, index }">
                <el-tooltip
                v-show="!row.editMode"
                  class="item"
                  effect="dark"
                  content="Download Document"
                  placement="top-start"
                >
                  <router-link
                    :to="`/api/orderfiles/${row.id}`"
                    class="btn-sm btn-download add-more-right-margin"
                    target="_blank"
                  >
                    <i class="el-icon-download"></i>
                  </router-link>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Edit Document"
                  placement="top-start"
                >
                  <el-button
                    size="mini"
                    :disabled="(isEditing && editingRowId !== row.id)"
                    :class="
                      row.editMode ? 'btn-primary' : 'btn-secondary'
                    "
                    :icon="row.editMode ? 'el-icon-check' : 'el-icon-edit'"
                    @click="handleEdit(row, index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                v-show="row.editMode"
                  class="item"
                  effect="dark"
                  content="Cancel Edit"
                  placement="top-start"
                >
                  <el-button
                    size="mini"
                    class="btn-secondary editing"
                    @click="handleCancel(row, index)"
                  >X</el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="!isPartnerNation"
                  class="item"
                  v-show="!row.editMode"
                  effect="dark"
                  content="Delete Document"
                  placement="top-start"
                >

                
                  <el-button
                    size="mini"
                    :disabled="(isEditing && editingRowId !== row.id) || isUSDocument(row)"
                    class="btn-secondary editing"
                    icon="el-icon-delete"
                    @click="handleDelete(row, index)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from "moment";
import {
  Table,
  TableColumn,
  Upload,
  Button,
  Tag,
  Select,
  Option,
  Alert,
  Form,
  FormItem,
  CheckboxGroup,
  Checkbox,
  Divider,
  Tooltip,
  Card,
} from "element-ui";
import { BaseButton, EditableCell } from "@/components";
import { mapActions, mapGetters } from "vuex";
import Utility from "@/mixins/utility/utility";
import swal from "sweetalert2";
import Treeselect from "@riophae/vue-treeselect";
import Util from "@/util/util";
import { EventBus } from "@/event-bus.js";

export default {
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [Utility],
  components: {
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Alert.name]: Alert,
    [Tag.name]: Tag,
    [Form.name]: Form,
    [Tooltip.name]: Tooltip,
    [FormItem.name]: FormItem,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    EditableCell,
    Treeselect,
  },
  mounted(){
    this.getDocumentTypes();
  },
  data() {
    return {
      editing: null,
      isEditing: false,
      editingRowId: null,
      fileTypeIds: [],
      // values: [],
      tableFields: [
        "documentType",
        "remark",
        "fileName",
        "fileSize",
        "uploadedBy",
        "uploadedDate",
      ],
      savingDocument: false,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
    };
  },
  computed: {
    ...mapGetters({
      orderMetadata: "orderMetadata/orderMetadata",
      documentTypes: "documents/documentTypes",
      documents: "documents/getDocuments",
      form: "documents/form",
      uploading: "documents/uploadingStatus",
      orderIdFromPreOrderDetail: "preOrderDetail/preOrder",
      preOrder: "preOrderDetail/preOrder",
      user: "authentication/getUser",
      isLoggedIn: "authentication/isLoggedIn",
      isOUSD: 'authentication/isOUSD',
      isViewOnly: 'authentication/isViewOnly',
      isPartnerNation: "authentication/isPartnerNation",

    }),
    orderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    orderId() {
      if (this.isOrderIdAvailable && this.orderIdFromRoute !== 0) {
        return this.orderIdFromRoute;
      } else {
        return this.orderIdFromPreOrderDetail.orderId;
      }
    },
    isOrderIdAvailable() {
      return (
        this.orderIdFromRoute != 0 ||
        (this.orderIdFromRoute != 0 &&
          this.orderIdFromPreOrderDetail &&
          this.orderIdFromPreOrderDetail.orderId != 0)
      );
    },
  
  },
  methods: {
    ...mapActions({
      getDocumentTypes: "documents/getDocumentTypes",
      updateDocumentType: "documents/updateDocumentType",
      getDocuments: "documents/getDocuments",
      updateDocumentData: "documents/updateDocument",
      deleteDocument: "documents/deleteDocument",
      downloadDocument: "documents/downloadDocument",
      disabledOtherEdits: "documents/disabledOtherEdits",
    }),
    isUSDocument(row){
      const fileType = row.fileTypeNames
      if(Array.isArray(fileType) && fileType.length === 1 && fileType[0] === 'PARTNER NATION' ){
          return false
        }
        return true
      },
    formatDate(date) {
      return Util.formatDateWithLocalTimezone(date);
    },
    handleEdit(row, index) {
      if (row.editMode) {
        // Row Updating Section
        row.editMode = false;

        this.updateDocumentData(row).then(() => {
          this.$toast.success("Updates Saved")
          this.editingRowId = null;
          this.isEditing = false;
        })
        
        this.getDocuments(this.orderId);
      } else {
        // Edit Section
        this.disabledOtherEdits(row.id);
        this.isEditing = true;
        this.editingRowId = row.id;
        row.editMode = true;
        row.canChangeDocumentType = true;
      }
    },
    handleCancel(row, index) {
      row.editMode = false;
      this.isEditing = false;
      this.editingRowId = null;
      this.getDocuments(this.orderId);
    },
    showLoadingSweetAlert(message) {
      new swal({
        position: "top-end",
        icon: "warning",
        title: "Please Wait Patiently",
        html: message,
        timer: 10000,
        showConfirmButton: false,
      });
    },
    handleDownload(row, index) {
      this.showAlertDialog("Success", "Downloading Started...", "success");
      let response = this.downloadDocument(row);
    },
    handleDelete(row, index) {
      let canDeletefile = true;
      const fileTypeName = row.fileTypeNames[0];
      const fileCount = this.documents.filter(
        (document) => document.fileTypeNames[0] === fileTypeName
      ).length;
      if (!canDeletefile) {
        this.$toast.error("This file cannot be deleted!!");
        return;
      }

      new swal({
        title: "Delete File",
        html: `Do you want to delete this file?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.deleteDocument(row).then((response) => {
           
            new swal({
              title: "",
              html: `${response.data}`,
              icon: "info",
              showCancelButton: false,
              confirmButtonColor: "#10b45a",
              confirmButtonText: "Okay",
            });
          });
          this.$toast.success("Your file has been deleted.");
        }
      });
    },
    async submitDocument() {

      let self = this;

      if (this.isOrderIdAvailable) {

        
        this.showLoadingSweetAlert(
          "Your document is uploading.<br><br>This message will disappear automatically in 10 seconds."
        );
        this.savingDocument = true;
        const PartnerNationId = this.documentTypes.filter((e)=> e.name === "PARTNER NATION");
        const formData = new FormData();
        formData.append("FileTypeIds", PartnerNationId[0].id);
        formData.append("OrderId", self.orderId);
        formData.append("Remark", self.form.remark);
        formData.append("IFile", self.form.file);
        formData.append("Signature", 'Partner Nation');

        self.$store
          .dispatch("documents/saveDocument", formData)
          .then(() => {
            this.savingDocument = false;
            self.fileTypeIds = [];
            self.clearAddForm();
              this.values = null
          })
          .catch((errorMessage) => {
            this.savingDocument = false;
            //console.log(errorMessage); //not handelled
          });
      } else {
        this.savingDocument = false;
        self.$toast.error("Please fill Pre Order details first!");
      }
    },
    clearAddForm() {
      this.form.documentType = null;
      this.form.remark = "";
      if (this.$refs.file) {
        this.$refs.file.value = null;
      }
      this.form.file = null;
    },
    handleFileUpload() {
      const uploadedFile = this.$refs.file.files[0];

      if (!Util.isSupportedFile(uploadedFile.name, /(\.pdf|\.png|\.jpg|\.jpeg)$/i)) {
        this.$toast.error("Invalid File Type!");
        this.$refs.file.value = null;
        return false;
      }
      this.form.file = this.$refs.file.files[0];
    },
  },
 
};
</script>

<style scoped>
.document-upload h3 {
  color: red;
}

.pt-20 {
  padding-top: 20px;
}

.document-table {
  widows: 100%;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #000;
}

.edit-cell:focus {
  outline-color: transparent;
}

.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #fff;
}

.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #10b45a;
  border-color: #10b45a;
}

label.el-checkbox.is-disabled.is-checked > .el-checkbox__label {
  color: rgba(34, 42, 66, 0.7);
}

.btn-primary {
  background-color: #10b45a;
  color: #fff;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-primary:hover {
  border-color: #10b45a;
  color: #fff;
  background-color: #10b45a;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-primary:focus {
  color: #fff;
  outline-color: transparent;
}

.btn-secondary:focus {
  outline-color: transparent;
}

.btn-download {
  background-color: #344675;
  color: #ffffff;
}

.btn-secondary-dark:focus {
  outline-color: transparent;
}

.uploaded-document.not-uploaded {
  color: #606266;
}

/* 
.uploaded-document.uploaded {
  color: #10b45a;
} */
.uploaded-document.not-uploaded i {
  color: red;
  font-weight: 900;
  padding-right: 0.3em;
}

.uploaded-document.uploaded i {
  color: #10b45a;
  font-weight: 900;
  padding-right: 0.3em;
}

.divider-green {
  background-color: #10b45a;
}

.btn-secondary {
  background-color: #d3d7e9;
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-secondary:hover {
  background-color: #cccccc;
  color: #1d253b;
  border-color: #cccccc;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-secondary-dark {
  background-color: #cccccc;
}

.btn-secondary-dark:hover {
  background-color: #d3d7e9;
  border: none;
  color: #1d253b;
}

.edit-cell {
  min-height: 35px;
  cursor: pointer;
}

.el-input__inner {
  border: 1px solid #10b45a;
}

.el-button.editing {
  color: #fff;
  border-color: red;
  background-color: red;
}
.add-more-right-margin {
  margin-right: 12px;
}
</style>
